var map = {
  "./bigquery.md": [
    "48841",
    "439"
  ],
  "./snowflake.md": [
    "30034",
    "750"
  ],
  "./postgresql.md": [
    "97886",
    "570"
  ],
  "./druid.md": [
    "20904",
    "129"
  ],
  "./sql-server.md": [
    "12582",
    "814"
  ],
  "./oracle.md": [
    "37690",
    "299"
  ],
  "./presto.md": [
    "63518",
    "690"
  ],
  "./redshift.md": [
    "785",
    "412"
  ],
  "./sqlite.md": [
    "6082",
    "770"
  ],
  "./athena.md": [
    "89059",
    "526"
  ],
  "./aws-rds.md": [
    "9446",
    "614"
  ],
  "./mariadb.md": [
    "23342",
    "179"
  ],
  "./mysql.md": [
    "38810",
    "159"
  ],
  "./starburst.md": [
    "58878",
    "443"
  ],
  "./sparksql.md": [
    "51509",
    "74"
  ],
  "./databricks.md": [
    "17149",
    "490"
  ],
  "./clickhouse.md": [
    "53837",
    "142"
  ],
  "./mongodb.md": [
    "12504",
    "352"
  ],
  "./vertica.md": [
    "36838",
    "492"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 1 | 16);
  });
}

webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 35512;
module.exports = webpackAsyncContext;
